export enum SideNavEvents {
  OPEN = 'pushBodySidenavOpen',
  CLOSE = 'pushBodySidenavClose',
  CLICKED = 'pushBodySidenavClicked',
  NAV_STOP_RESIZE = 'navbarStopResize',
}
